import { ViewfinderOverlay } from "./styled"

const CORNER_INSET = 4
const CORNER_ARM = 18
const CORNER_RADIUS = 8

const CORNER_PATHS = [
  `M ${CORNER_ARM} ${CORNER_INSET} H ${CORNER_INSET + CORNER_RADIUS} A ${CORNER_RADIUS} ${CORNER_RADIUS} 0 0 0 ${CORNER_INSET} ${CORNER_INSET + CORNER_RADIUS} V ${CORNER_ARM}`,
  `M ${100 - CORNER_ARM} ${CORNER_INSET} H ${100 - CORNER_INSET - CORNER_RADIUS} A ${CORNER_RADIUS} ${CORNER_RADIUS} 0 0 1 ${100 - CORNER_INSET} ${CORNER_INSET + CORNER_RADIUS} V ${CORNER_ARM}`,
  `M ${CORNER_INSET} ${100 - CORNER_ARM} V ${100 - CORNER_INSET - CORNER_RADIUS} A ${CORNER_RADIUS} ${CORNER_RADIUS} 0 0 0 ${CORNER_INSET + CORNER_RADIUS} ${100 - CORNER_INSET} H ${CORNER_ARM}`,
  `M ${100 - CORNER_INSET} ${100 - CORNER_ARM} V ${100 - CORNER_INSET - CORNER_RADIUS} A ${CORNER_RADIUS} ${CORNER_RADIUS} 0 0 1 ${100 - CORNER_INSET - CORNER_RADIUS} ${100 - CORNER_INSET} H ${100 - CORNER_ARM}`,
]

const Viewfinder = () => (
  <ViewfinderOverlay
    viewBox="0 0 100 100"
    aria-hidden
  >
    {CORNER_PATHS.map((path) => (
      <path
        key={path}
        d={path}
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ))}
  </ViewfinderOverlay>
)

export default Viewfinder
